<template>
  <div
    class="a-modal-pop row justify-content-center align-items-center collapse"
    id="pz-video-report"
    ref="VideoReport"
  >
    <div class="modal-pop modal-pop-lg shadow-lg bg-white d-flex flex-column">
      <div
        class="modal-pop-header border-bottom p-3 d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">{{ mg_survey.surveyName }}</h5>
        <button
          class="btn btn-link text-dark"
          type="button"
          data-toggle="collapse"
          data-target="#pz-video-report"
          aria-expanded="false"
          aria-controls="pz-video-report"
        >
          <i class="pz-icon icon-close"></i>
        </button>
      </div>
      <div class="modal-pop-body p-4 overflow-auto h-100">
        <form ref="SurveyForm" v-if="isShowSurvey">
          <SurveyItem
            :p_surveyItem="surveyItem"
            :p_objValues="{
              bulletId: video.bulletId,
              postPlatform: 'pc',
              description: `${polyvCurrentTime}(${c_speed}X)：`,
            }"
            :key="surveyItem.surveyItemId"
            v-for="surveyItem in mg_survey.itemList"
          />
        </form>
        <!-- <div class="mb-4">
          <h5>讲义问题</h5>
          <a href="javascript:undefined" class="qa-taglist f-14 active">
            sdfsdf
          </a>

          <a href="javascript:undefined" class="qa-taglist f-14"> sdfsdf </a>
        </div>
        <div class="mb-4">
          <h5>描述</h5>
          <textarea class="form-control" rows="5"></textarea>
        </div> -->
      </div>
      <div
        class="modal-pop-footer border-top p-3 d-flex justify-content-center"
      >
        <button
          type="button"
          class="btn btn-primary py-2 px-4 ml-3"
          :disabled="c_isSubmitDisabled"
          @click.prevent="makeSurveyNew"
        >
          提交
        </button>
        <button
          type="button"
          class="btn btn-secondary py-2 px-4 ml-3"
          data-toggle="collapse"
          data-target="#pz-video-report"
          aria-expanded="false"
          aria-controls="pz-video-report"
        >
          取消
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import Swal from 'sweetalert2';

import SurveyItem from './SurveyItem.vue';

import { SurveyMixin } from '@/mixins/Survey/Survey';

const objPolyvSpeed = {
  0: 1,
  1: 1.3,
  2: 1.5,
  3: 2,
};

const getTimeStr = (time) => {
  const hours = time / 3600;
  const minutes = (time % 3600) / 60;
  const seconds = time % 60;
  let lstHMS = hours > 1 ? [hours, minutes, seconds] : [minutes, seconds];
  lstHMS = _.map(lstHMS, (val) => `0${Math.floor(val)}`.slice(-2));
  const strTime = _.join(lstHMS, ':');
  return strTime;
};

export default {
  name: 'video-report',

  mixins: [SurveyMixin],

  components: {
    SurveyItem,
  },

  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isOpened: false,
      isShowSurvey: false,

      polyvCurrentTime: null,
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    defaultSpeed() {
      return this.mg_userInfo && this.mg_userInfo.defaultSpeed;
    },

    c_speed() {
      return objPolyvSpeed[this.defaultSpeed];
    },

    ///
    c_surveyId() {
      return 3;
    },

    ///
    c_isSubmitDisabled() {
      return !this.mg_isSurveyReady;
    },
  },

  methods: {
    ///
    async doAfterMakeSurveyNew() {
      await Swal.fire({
        // position: 'top-end',
        backdrop: false,
        icon: 'success',
        width: '400px',
        title: `已经反馈问题`,
        showConfirmButton: false,
        timer: 800,
      });
      $(this.$refs.VideoReport).collapse('hide');
    },
  },

  mounted() {
    $(this.$refs.VideoReport)
      .on('show.bs.collapse', () => {
        this.polyvCurrentTime = getTimeStr(window.player.j2s_getCurrentTime());
        this.isShowSurvey = true;
        if (!this.isOpened) {
          this.isOpened = true;
          this.getSurvey();
        }
      })
      .on('hidden.bs.collapse', () => {
        this.isShowSurvey = false;
      });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
